module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-pohlavi"
    }
  }, [_c('h1', [_vm._v("Pohlaví")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ispohlavivalid() && this.tryescape),
      expression: "!ispohlavivalid() && this.tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.ispohlavivalid() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("Musíte vybrat pohlaví vašeho mazlíčka\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "pohlavi-pes-fena"
  }, [_c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.ispohlavivalid() && this.tryescape
    }
  }, _vm._l((_vm.pohlavi), function(item) {
    return _c('div', {
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.pohlavi.value),
        expression: "mazlicek.pohlavi.value"
      }],
      attrs: {
        "type": "radio",
        "id": item.val
      },
      domProps: {
        "value": item.val,
        "checked": _vm._q(_vm.mazlicek.pohlavi.value, item.val)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.mazlicek.pohlavi, "value", item.val)
        }, _vm.pohlaviOnChange]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.val
      }
    }, [_vm._v("\n                        " + _vm._s(item.txt) + "\n                    ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mazlicek.pohlavi.value === 'fena'),
      expression: "mazlicek.pohlavi.value === 'fena'"
    }],
    staticClass: "laktujici-fena"
  }, [_c('h2', [_vm._v("Je březí nebo kojící?")]), _vm._v(" "), _c('div', {
    staticClass: "form-radios"
  }, _vm._l((_vm.breziLaktujici), function(item) {
    return _c('div', {
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.pohlavi.laktujici),
        expression: "mazlicek.pohlavi.laktujici"
      }],
      attrs: {
        "type": "radio",
        "id": String(item.val) + 'laktujci'
      },
      domProps: {
        "value": item.val,
        "checked": _vm._q(_vm.mazlicek.pohlavi.laktujici, item.val)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.mazlicek.pohlavi, "laktujici", item.val)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": String(item.val) + 'laktujci'
      }
    }, [_vm._v("\n                        " + _vm._s(item.txt) + "\n                    ")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$v.mazlicek.$invalid),
      expression: "this.$v.mazlicek.$invalid"
    }],
    staticClass: "veterinar-info"
  }, [_vm._m(0)])])]), _vm._v(" "), _c('info', {
    attrs: {
      "krok": 5
    }
  }), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "disableNext": !_vm.valid,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Další kroky musíme řešit individuálně. "), _c('a', {
    attrs: {
      "href": "/kontakty"
    }
  }, [_vm._v("Ozvěte se nám.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-461f0994","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/05Pohlavi.vue
// module id = 573
// module chunks = 1